import { render, staticRenderFns } from "./CartRecommendProducts.vue?vue&type=template&id=530f5fa0&scoped=true"
import script from "./CartRecommendProducts.vue?vue&type=script&lang=js"
export * from "./CartRecommendProducts.vue?vue&type=script&lang=js"
import style0 from "./CartRecommendProducts.vue?vue&type=style&index=0&id=530f5fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f5fa0",
  null
  
)

export default component.exports